import React from "react";
import { Button } from "reactstrap";
import swal from "sweetalert";

const Decimal = ({ onToggle, showAsInteger }) => {
  const handleToggle = () => {
    const newShowAsInteger = !showAsInteger;
    onToggle(newShowAsInteger);
    swal({
      title: showAsInteger ? "Decimal View Enabled" : "Decimal View Disabled",
      text: showAsInteger
        ? "All values will now show with decimals"
        : "All values will now not show with decimals",
      icon: "success",
      timer: 1500,
      buttons: false,
    });
  };

  return (
    <Button
      color="secondary"
      className="button-22"
      onClick={handleToggle}
      id="invoiceButton"
    >
      {showAsInteger ? "Show Decimals" : "Hide Decimals"}
    </Button>
  );
};



export default Decimal;